import { jsx as _jsx } from "react/jsx-runtime";
import { theme } from '@prophecy/theme';
import { Root } from '@radix-ui/react-separator';
import { forwardRef } from 'react';
import styled from 'styled-components';
const tokens = {
    Separator: {
        borderColor: theme.colors.gray200
    },
    Content: {
        backgorund: theme.colors.white,
        padding: theme.spaces.x12
    }
};
const StyledSeparator = styled(Root) `
  position: relative;
  ${(props) => props.orientation === 'vertical'
    ? `
        border-left: 1px solid ${tokens.Separator.borderColor};
        height: 100%;
      `
    : `border-top: 1px solid ${tokens.Separator.borderColor};`}
`;
const StyledSeparatorContent = styled.div `
  background: ${tokens.Content.backgorund};
  position: absolute;
  padding: 0 ${tokens.Content.padding};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const Separator = forwardRef(({ children, ...props }, ref) => {
    return (_jsx(StyledSeparator, { ...props, ref: ref, children: children ? _jsx(StyledSeparatorContent, { children: children }) : null }));
});
